import numeral from 'numeral';

const filters = {
  formatNumber(value) {
    return numeral(value).format('0,0[.]00').replaceAll(',', ' ');
  },
  capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  },
};
export default filters;
